import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SetupQuiz = () => {
  const [quizTitle, setQuizTitle] = useState('');
  const [questions, setQuestions] = useState([]);
  const [message, setMessage] = useState('');
  const [courses, setCourses] = useState([]); // To store fetched courses
  const [selectedCourse, setSelectedCourse] = useState(''); // To store selected course ID

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      const response = await axios.get('https://schoolofservice.co.za/backend/fetch_courses.php');
      if (response.data.status === 'success') {
        setCourses(response.data.data);
      } else {
        setMessage('Failed to load courses.');
      }
    } catch (error) {
      setMessage('An error occurred while fetching courses.');
    }
  };

  const handleAddQuestion = () => {
    setQuestions([...questions, { questionText: '', options: [], correctAnswer: '', questionType: 'radio', marks: 1 }]);
  };

  const handleQuestionChange = (index, event) => {
    const newQuestions = [...questions];
    newQuestions[index][event.target.name] = event.target.value;
    setQuestions(newQuestions);
  };

  const handleOptionChange = (index, event) => {
    const newQuestions = [...questions];
    const newOptions = [...newQuestions[index].options];
    newOptions[event.target.dataset.index] = event.target.value;
    newQuestions[index].options = newOptions;
    setQuestions(newQuestions);
  };

  const handleAddOption = (index) => {
    const newQuestions = [...questions];
    newQuestions[index].options.push('');
    setQuestions(newQuestions);
  };

  const handleCorrectAnswerChange = (index, event) => {
    const newQuestions = [...questions];
    newQuestions[index].correctAnswer = event.target.value;
    setQuestions(newQuestions);
  };

  const handleMarksChange = (index, event) => {
    const newQuestions = [...questions];
    newQuestions[index].marks = parseInt(event.target.value, 10);
    setQuestions(newQuestions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!quizTitle || !selectedCourse || questions.length === 0) {
      setMessage('Please complete all fields before submitting.');
      return;
    }

    const quizData = {
      quizTitle,
      courseId: selectedCourse,
      questions,
    };

    try {
      const response = await axios.post('https://schoolofservice.co.za/backend/save_quiz.php', quizData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.data.status === 'success') {
        setMessage('Quiz setup submitted successfully!');
      } else {
        setMessage('Failed to submit quiz: ' + response.data.message);
      }
    } catch (error) {
      setMessage('An error occurred while submitting the quiz.');
    }
  };

  return (
    <div>
      <h3>Set Up Quiz</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="quizTitle" className="form-label">Quiz Title</label>
          <input
            type="text"
            className="form-control"
            id="quizTitle"
            value={quizTitle}
            onChange={(e) => setQuizTitle(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="course" className="form-label">Select Course</label>
          <select
            className="form-select"
            id="courseSelection"
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            required
          >
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course.coursesID} value={course.coursesID}>
                {course.courseName}
              </option>
            ))}
          </select>
        </div>

        <button type="button" className="btn btn-secondary" onClick={handleAddQuestion}>Add Question</button>

        {questions.map((question, index) => (
          <div key={index} className="mb-3">
            <label className="form-label">Question {index + 1}</label>
            <input
              type="text"
              className="form-control"
              name="questionText"
              value={question.questionText}
              onChange={(e) => handleQuestionChange(index, e)}
              placeholder="Enter question text"
              required
            />

            <div className="mt-2">
              <label>Marks: </label>
              <input
                type="number"
                className="form-control"
                name="marks"
                value={question.marks}
                onChange={(e) => handleMarksChange(index, e)}
                min="1"
                required
              />
            </div>

            <div className="mt-2">
              <label>Question Type: </label>
              <select
                className="form-select"
                name="questionType"
                value={question.questionType}
                onChange={(e) => handleQuestionChange(index, e)}
              >
                <option value="radio">Multiple Choice</option>
                <option value="checkbox">Checkboxes</option>
                <option value="text">Text</option>
              </select>
            </div>

            <div className="mt-3">
              {question.options.map((option, i) => (
                <div key={i} className="form-check">
                  <input
                    type="text"
                    className="form-control d-inline-block w-75"
                    value={option}
                    onChange={(e) => handleOptionChange(index, e)}
                    data-index={i}
                    placeholder={`Option ${i + 1}`}
                    required
                  />
                </div>
              ))}
              <button type="button" className="btn btn-secondary mt-2" onClick={() => handleAddOption(index)}>Add Option</button>

              {question.questionType !== 'text' && (
                <div className="mt-2">
                  <label htmlFor={`correctAnswer${index}`} className="form-label">Set Correct Answer</label>
                  <select
                    className="form-select"
                    id={`correctAnswer${index}`}
                    value={question.correctAnswer}
                    onChange={(e) => handleCorrectAnswerChange(index, e)}
                    required
                  >
                    <option value="">Select Correct Answer</option>
                    {question.options.map((option, i) => (
                      <option key={i} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </div>
          </div>
        ))}

        <button type="submit" className="btn btn-primary mt-4">Submit Quiz</button>
      </form>

      {message && <div className="mt-3 alert alert-info">{message}</div>}
    </div>
  );
};

export default SetupQuiz;
